import { Component, Input, OnChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Sequential } from 'src/app/api/api-campaigns.service.generated';

@Component({
  selector: 'app-sequential-strategy-edit',
  templateUrl: './sequential-strategy-edit.component.html',
  styleUrls: ['./sequential-strategy-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
  ]
})
export class SequentialStrategyEditComponent implements OnChanges {

  @Input() strategy: Sequential;

  constructor() { }

  ngOnChanges(): void {
    if (!this.strategy) return;
    if (this.strategy && !this.strategy.children)
      this.strategy.children = [];
  }


}
